import type { CollectionsApi } from '@wix/wix-code-collections-api'

export const getIsCollectionDeleted =
  (collectionsApi: CollectionsApi) => async (collectionId: string) =>
    (await collectionsApi.getAll({ includeHiddenAppCollections: true })).every(
      c => c.id !== collectionId || c.isDeleted,
    )
